import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Grid } from '../grid';
import { Widget, WIDGET_MAX_WIDTH } from '.';
export const WidgetGrid = (props) => {
    return (_jsx(Grid, { ...props, columnMaxWidth: WIDGET_MAX_WIDTH, loading: props.loading
            ? {
                count: props.loading,
                component: (_jsx(Widget, { loading: true, children: _jsx(Widget.List, {}) }))
            }
            : undefined }));
};
